import ClockIcon from "../../../Components/Common/svg/reports/clockicon";
import DollarSignIcon from "../../../Components/Common/svg/reports/dollarsign";
import MoneyBagIcon from "../../../Components/Common/svg/reports/moneybagicon";
import ShippingIcon from "../../../Components/Common/svg/Shippingicon";
import ShoppingIcon from "../../../Components/Common/svg/shoppingicon";
import { formatPrice } from "../../../utils/formatPrice";

export const tabs = [
  { id: 3, label: "attachments", name: "المرفقات" },
  { id: 4, label: "companyInfo", name: "معلومات الشركة" },
  { id: 5, label: "workingDays", name: "مواعيد العمل" },
  { id: 6, label: "curioer", name: "السائقين" },
  { id: 2, label: "reports", name: " التقارير" },
  { id: 1, label: "zones", name: "المناطق" },
  { id: 9, label: "transactions", name: "المعاملات" },  
   
  { id: 8, label: "finance", name: "المالية" },
];

export const shippingStatsConfig = (delivery_stats ,currency_factor) => [
  {
    title: "الطلبات الجارية",
    count: delivery_stats?.ongoing_orders,
    color: "#FFCC03",
    icon: <ShoppingIcon/>,
    bgIcon: "#E6F3EF",  
  },
  {
    title: "إجمالي الأرباح",  
    count: delivery_stats?.total_revenue ? formatPrice(currency_factor, delivery_stats.total_revenue) : 0,
    color: "#003726",
    icon: <MoneyBagIcon style={{ color: "#003726" }} />,
    bgIcon: "#8AC6B4",  
  },
  {
    title: "التسليم في الوقت",
    count: delivery_stats?.success_rate,
    color: "#616161",
    icon: <ClockIcon />, 
    bgIcon: "#EBEBEB",
  },
  {
    title: "الطلبات",  
    count: delivery_stats?.total_orders,
    color: "#FC0",
    icon: <DollarSignIcon />, 
    bgIcon: "#FFFCE9",
  },
  {
    title: "السائقين",
    count:delivery_stats?.total_couriers,
    color: "#0F2B42",
    icon: <ShippingIcon color="#FFCC00" />,
    bgIcon: "#E7EAEC",
  },
];

export const achievementsStatsConfig = (achievements) => [
  {
    title: " طلب شهرياً",
    count: achievements.monthly_orders,
    color: "#FFCC03",
    icon: "",
    bgIcon: "#E6F3EF",
  },
  {
    title: achievements.growth_label,
    count: achievements.growth_percentage,
    color: "#FFCC00",
    icon: "",
    bgIcon: "#fff",
  },

];

